import { Helmet } from 'react-helmet-async'
import Breadcrumb from '@/components/layout/Breadcrumb'
import Card from '@/components/ui/Card'
import { useTranslation } from 'react-i18next'

export default function InstitutionsPage() {
  const { t } = useTranslation()
  const breadcrumbItems = [
    { label: t('common.home'), to: '/' },
    { label: t('public.institutions.title') },
  ]

  return (
    <>
      <Helmet>
        <title>{t('public.institutions.title')} - سكينة</title>
        <meta name="description" content={t('public.institutions.seo.description')} />
      </Helmet>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Breadcrumb items={breadcrumbItems} className="mb-6" />

        <div className="mb-8">
          <h1 className="text-4xl font-bold text-gray-900 dark:text-gray-100 mb-4">{t('public.institutions.title')}</h1>
          <p className="text-lg text-gray-600 dark:text-gray-400">{t('public.institutions.intro')}</p>
        </div>

        <Card className="p-6">
          <p className="text-gray-700 dark:text-gray-300">{t('common.comingSoon')}</p>
        </Card>
      </div>
    </>
  )
}

